import { render, staticRenderFns } from "./view-approved-salary-routine.vue?vue&type=template&id=ae837f1c"
import script from "./view-approved-salary-routine.vue?vue&type=script&lang=js"
export * from "./view-approved-salary-routine.vue?vue&type=script&lang=js"
import style0 from "./view-approved-salary-routine.vue?vue&type=style&index=0&id=ae837f1c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports